import { fetcher, queryString, useRecoilQuery } from '@shared/hooks/recoil-query';
import { LowerRole } from '@shared/types';

import { GiftStoreRole } from '../giftOrder/giftOrder.interface';
import {
  giftCouponByCodeDataAtomFamily,
  giftCouponByCodeStatusAtomFamily,
  giftCouponByIdDataAtomFamily,
  giftCouponByIdStatusAtomFamily,
  giftCouponRedemptionListDataAtom,
  giftCouponRedemptionListStatusAtom,
} from './giftCoupon.atom';

// 코드로 쿠폰 조회 URL (public)
const giftCouponByCodeUrl = (code: string) => {
  return `/${LowerRole.Public}/gift-coupon/code/${code}`;
};

export const useGiftCouponByCodeHook = (code: string, skip = false) => {
  useRecoilQuery(
    giftCouponByCodeStatusAtomFamily(code),
    giftCouponByCodeDataAtomFamily(code),
    giftCouponByCodeUrl(code),
    fetcher,
    skip || !code,
  );
};

// ID로 쿠폰 조회 URL (public)
const giftCouponByIdUrl = (id: string) => {
  return `/${LowerRole.Public}/gift-coupon/${id}`;
};

export const useGiftCouponByIdHook = (id: string, skip = false) => {
  useRecoilQuery(
    giftCouponByIdStatusAtomFamily(id),
    giftCouponByIdDataAtomFamily(id),
    giftCouponByIdUrl(id),
    fetcher,
    skip || !id,
  );
};

// 교환 신청된 쿠폰 목록 조회 URL (seller/admin)
const giftCouponRedemptionListUrl = (role: GiftStoreRole) => {
  return `/${role}/gift-coupon?${queryString({
    populate: [
      {
        path: 'giftItem',
        populate: [
          { path: 'image' },
          {
            path: 'giftItemInfo',
            populate: [
              { path: 'image' },
              { path: 'giftItemBrand' },
            ],
          },
        ],
      },
      {
        path: 'selectedChoiceUnit',
        populate: [
          { path: 'image' },
          { path: 'giftItemBrand' },
        ],
      },
      { path: 'giftOrder' },
    ],
    options: { sort: { createdAt: -1 } },
  })}`;
};

export const useGiftCouponRedemptionListHook = (role: GiftStoreRole, skip = false) => {
  useRecoilQuery(
    giftCouponRedemptionListStatusAtom,
    giftCouponRedemptionListDataAtom,
    giftCouponRedemptionListUrl(role),
    fetcher,
    skip,
  );
};
